/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.21.588 on 2025-10-15 09:40:27.

export type RestOptions = {
    qparams?: { [p: string]: any }
    _cfg?: {
        nogestionaerror?: boolean
    }
};;

export interface HttpClient {

    request<R>(requestConfig: { method: string; url: string; queryParams?: any; data?: any; copyFn?: (data: R) => R; options?: RestOptions; }): RestResponse<R>;
}

export interface IApiRestCurriculums {

    /**
     * HTTP POST /api/_cv/n
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV
     */
    nuevoCV(alta: ICurriculumRequestAlta, options?: RestOptions): RestResponse<ICurriculumState>;

    /**
     * HTTP POST /api/_cv/n/{token}/f
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoFicheroParaCV
     */
    nuevoFicheroParaCV(token: string, queryParams?: { idcv?: number; }, options?: RestOptions): RestResponse<ICurriculumState>;

    /**
     * HTTP POST /api/_cv/n2
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV_Secured
     */
    nuevoCV_Secured(alta: ICurriculumRequestAlta, options?: RestOptions): RestResponse<ICurriculumState>;
}

export class IApiRestCurriculumsClient implements IApiRestCurriculums {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/_cv/n
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV
     */
    nuevoCV(alta: ICurriculumRequestAlta, options?: RestOptions): RestResponse<ICurriculumState> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/_cv/n`, data: alta, options: options });
    }

    /**
     * HTTP POST /api/_cv/n/{token}/f
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoFicheroParaCV
     */
    nuevoFicheroParaCV(token: string, queryParams?: { idcv?: number; }, options?: RestOptions): RestResponse<ICurriculumState> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/_cv/n/${token}/f`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /api/_cv/n2
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestCurriculums.nuevoCV_Secured
     */
    nuevoCV_Secured(alta: ICurriculumRequestAlta, options?: RestOptions): RestResponse<ICurriculumState> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/_cv/n2`, data: alta, options: options });
    }
}

export interface IApiRestDatos {

    /**
     * HTTP GET /api/priv/_dat/doc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.tiposParaDocuemntos
     */
    tiposParaDocuemntos(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<ITiposDatosDoc>;

    /**
     * HTTP POST /api/priv/_dat/st/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.nuevoEstadoDoc
     */
    nuevoEstadoDoc(cambioEstado: ICambioEstadoDoc, options?: RestOptions): RestResponse<IGestionEstado>;

    /**
     * HTTP GET /api/priv/_dat/st/gest
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.leerEstadosDoc
     */
    leerEstadosDoc(options?: RestOptions): RestResponse<IGestionEstadosDoc>;

    /**
     * HTTP PUT /api/priv/_dat/st/{idestado}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.cambioEstadoDoc
     */
    cambioEstadoDoc(idestado: number, cambioEstado: ICambioEstadoDoc, options?: RestOptions): RestResponse<IGestionEstado>;
}

export class IApiRestDatosClient implements IApiRestDatos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_dat/doc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.tiposParaDocuemntos
     */
    tiposParaDocuemntos(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<ITiposDatosDoc> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_dat/doc`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP POST /api/priv/_dat/st/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.nuevoEstadoDoc
     */
    nuevoEstadoDoc(cambioEstado: ICambioEstadoDoc, options?: RestOptions): RestResponse<IGestionEstado> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_dat/st/add`, data: cambioEstado, options: options });
    }

    /**
     * HTTP GET /api/priv/_dat/st/gest
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.leerEstadosDoc
     */
    leerEstadosDoc(options?: RestOptions): RestResponse<IGestionEstadosDoc> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_dat/st/gest`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_dat/st/{idestado}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDatos.cambioEstadoDoc
     */
    cambioEstadoDoc(idestado: number, cambioEstado: ICambioEstadoDoc, options?: RestOptions): RestResponse<IGestionEstado> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_dat/st/${idestado}`, data: cambioEstado, options: options });
    }
}

export interface IApiRestDocumentacion {

    /**
     * HTTP PUT /api/priv/_doc/notif
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaNotifDocDoc
     */
    actualizaReglaNotifDocDoc(notifDoc: IModelNotificacionDoc, queryParams?: { id?: number; }, options?: RestOptions): RestResponse<IModelNotificacionDoc>;

    /**
     * HTTP GET /api/priv/_doc/notifs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasNotificacionDoc
     */
    reglasNotificacionDoc(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<IGestionReglasNotifDoc>;

    /**
     * HTTP PUT /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaValidacionDocObligatoria
     */
    actualizaReglaValidacionDocObligatoria(notifDoc: IModelDocReq, queryParams?: { id?: number; }, options?: RestOptions): RestResponse<IReglaValidacionDoc>;

    /**
     * HTTP GET /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasValidacionDocObligatoria
     */
    reglasValidacionDocObligatoria(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<IGestionReglasValidacionDoc>;
}

export class IApiRestDocumentacionClient implements IApiRestDocumentacion {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /api/priv/_doc/notif
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaNotifDocDoc
     */
    actualizaReglaNotifDocDoc(notifDoc: IModelNotificacionDoc, queryParams?: { id?: number; }, options?: RestOptions): RestResponse<IModelNotificacionDoc> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_doc/notif`, queryParams: queryParams, data: notifDoc, options: options });
    }

    /**
     * HTTP GET /api/priv/_doc/notifs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasNotificacionDoc
     */
    reglasNotificacionDoc(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<IGestionReglasNotifDoc> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_doc/notifs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP PUT /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.actualizaReglaValidacionDocObligatoria
     */
    actualizaReglaValidacionDocObligatoria(notifDoc: IModelDocReq, queryParams?: { id?: number; }, options?: RestOptions): RestResponse<IReglaValidacionDoc> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_doc/valida`, queryParams: queryParams, data: notifDoc, options: options });
    }

    /**
     * HTTP GET /api/priv/_doc/valida
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestDocumentacion.reglasValidacionDocObligatoria
     */
    reglasValidacionDocObligatoria(queryParams?: { f?: string; }, options?: RestOptions): RestResponse<IGestionReglasValidacionDoc> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_doc/valida`, queryParams: queryParams, options: options });
    }
}

export interface IApiRestEdicionFormularios {

    /**
     * HTTP POST /api/priv/_f/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoFormulario
     */
    nuevoFormulario(alta: IEdicionForm, options?: RestOptions): RestResponse<IEdicionForm>;

    /**
     * HTTP GET /api/priv/_f/ed/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.leerFormulario
     */
    leerFormulario(idform: number, options?: RestOptions): RestResponse<IFormCompleto>;

    /**
     * HTTP POST /api/priv/_f/ed/{idform}/b
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoBloque
     */
    nuevoBloque(idform: number, bloque: IFormBloque, options?: RestOptions): RestResponse<IFormBloque>;

    /**
     * HTTP PUT /api/priv/_f/ed/{idform}/b/{idbloque}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaBloque
     */
    actualizaBloque(idform: number, idbloque: number, bloque: IFormBloque, options?: RestOptions): RestResponse<IFormBloque>;

    /**
     * HTTP PUT /api/priv/_f/f/{idform}/dup
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.duplicaFormulario
     */
    duplicaFormulario(idform: number, options?: RestOptions): RestResponse<IEdicionForm>;

    /**
     * HTTP GET /api/priv/_f/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaFormularios
     */
    listaFormularios(options?: RestOptions): RestResponse<IEdicionFormularios>;

    /**
     * HTTP GET /api/priv/_f/listp
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaPreguntas
     */
    listaPreguntas(options?: RestOptions): RestResponse<IListaPreguntas>;

    /**
     * HTTP PUT /api/priv/_f/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaForm
     */
    actualizaForm(alta: IEdicionForm, options?: RestOptions): RestResponse<IEdicionForm>;
}

export class IApiRestEdicionFormulariosClient implements IApiRestEdicionFormularios {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_f/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoFormulario
     */
    nuevoFormulario(alta: IEdicionForm, options?: RestOptions): RestResponse<IEdicionForm> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_f/add`, data: alta, options: options });
    }

    /**
     * HTTP GET /api/priv/_f/ed/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.leerFormulario
     */
    leerFormulario(idform: number, options?: RestOptions): RestResponse<IFormCompleto> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_f/ed/${idform}`, options: options });
    }

    /**
     * HTTP POST /api/priv/_f/ed/{idform}/b
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.nuevoBloque
     */
    nuevoBloque(idform: number, bloque: IFormBloque, options?: RestOptions): RestResponse<IFormBloque> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_f/ed/${idform}/b`, data: bloque, options: options });
    }

    /**
     * HTTP PUT /api/priv/_f/ed/{idform}/b/{idbloque}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaBloque
     */
    actualizaBloque(idform: number, idbloque: number, bloque: IFormBloque, options?: RestOptions): RestResponse<IFormBloque> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_f/ed/${idform}/b/${idbloque}`, data: bloque, options: options });
    }

    /**
     * HTTP PUT /api/priv/_f/f/{idform}/dup
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.duplicaFormulario
     */
    duplicaFormulario(idform: number, options?: RestOptions): RestResponse<IEdicionForm> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_f/f/${idform}/dup`, options: options });
    }

    /**
     * HTTP GET /api/priv/_f/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaFormularios
     */
    listaFormularios(options?: RestOptions): RestResponse<IEdicionFormularios> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_f/list`, options: options });
    }

    /**
     * HTTP GET /api/priv/_f/listp
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.listaPreguntas
     */
    listaPreguntas(options?: RestOptions): RestResponse<IListaPreguntas> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_f/listp`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_f/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionFormularios.actualizaForm
     */
    actualizaForm(alta: IEdicionForm, options?: RestOptions): RestResponse<IEdicionForm> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_f/save`, data: alta, options: options });
    }
}

export interface IApiRestEdicionPreguntas {

    /**
     * HTTP POST /api/priv/_q/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.nuevoPregunta
     */
    nuevoPregunta(alta: IEdicionPregunta, options?: RestOptions): RestResponse<IEdicionPregunta>;

    /**
     * HTTP GET /api/priv/_q/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.listaPreguntas
     */
    listaPreguntas(options?: RestOptions): RestResponse<IEdicionPreguntas>;

    /**
     * HTTP GET /api/priv/_q/pr_uses/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.usosPregunta
     */
    usosPregunta(idpreg: number, options?: RestOptions): RestResponse<ISeleccionForm[]>;

    /**
     * HTTP PUT /api/priv/_q/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.actualizaPregunta
     */
    actualizaPregunta(alta: IEdicionPregunta, options?: RestOptions): RestResponse<IEdicionPregunta>;

    /**
     * HTTP GET /api/priv/_q/v/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.leerPregunta
     */
    leerPregunta(idpreg: number, options?: RestOptions): RestResponse<IPregCompleto>;
}

export class IApiRestEdicionPreguntasClient implements IApiRestEdicionPreguntas {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_q/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.nuevoPregunta
     */
    nuevoPregunta(alta: IEdicionPregunta, options?: RestOptions): RestResponse<IEdicionPregunta> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_q/add`, data: alta, options: options });
    }

    /**
     * HTTP GET /api/priv/_q/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.listaPreguntas
     */
    listaPreguntas(options?: RestOptions): RestResponse<IEdicionPreguntas> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_q/list`, options: options });
    }

    /**
     * HTTP GET /api/priv/_q/pr_uses/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.usosPregunta
     */
    usosPregunta(idpreg: number, options?: RestOptions): RestResponse<ISeleccionForm[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_q/pr_uses/${idpreg}`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_q/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.actualizaPregunta
     */
    actualizaPregunta(alta: IEdicionPregunta, options?: RestOptions): RestResponse<IEdicionPregunta> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_q/save`, data: alta, options: options });
    }

    /**
     * HTTP GET /api/priv/_q/v/{idpreg}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestEdicionPreguntas.leerPregunta
     */
    leerPregunta(idpreg: number, options?: RestOptions): RestResponse<IPregCompleto> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_q/v/${idpreg}`, options: options });
    }
}

export interface IApiRestFormularios {

    /**
     * HTTP GET /api/priv/_f/_vm/{idmenu}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormularioDeMenu
     */
    leerFormularioDeMenu(idmenu: number, options?: RestOptions): RestResponse<ICuestionario2>;

    /**
     * HTTP GET /api/priv/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormulario
     */
    leerFormulario(idmenu: number, idform: number, options?: RestOptions): RestResponse<ICuestionario>;
}

export class IApiRestFormulariosClient implements IApiRestFormularios {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_f/_vm/{idmenu}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormularioDeMenu
     */
    leerFormularioDeMenu(idmenu: number, options?: RestOptions): RestResponse<ICuestionario2> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_f/_vm/${idmenu}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormularios.leerFormulario
     */
    leerFormulario(idmenu: number, idform: number, options?: RestOptions): RestResponse<ICuestionario> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_f/${idmenu}/${idform}`, options: options });
    }
}

export interface IApiRestFormulariosPublicos {

    /**
     * HTTP GET /api/publ/_f/_vm/{idmenu}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublicoDeMenu
     */
    leerFormularioPublicoDeMenu(idmenu: number, options?: RestOptions): RestResponse<ICuestionario2>;

    /**
     * HTTP GET /api/publ/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublico
     */
    leerFormularioPublico(idmenu: number, idform: number, options?: RestOptions): RestResponse<ICuestionario>;
}

export class IApiRestFormulariosPublicosClient implements IApiRestFormulariosPublicos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/publ/_f/_vm/{idmenu}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublicoDeMenu
     */
    leerFormularioPublicoDeMenu(idmenu: number, options?: RestOptions): RestResponse<ICuestionario2> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/publ/_f/_vm/${idmenu}`, options: options });
    }

    /**
     * HTTP GET /api/publ/_f/{idmenu}/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestFormulariosPublicos.leerFormularioPublico
     */
    leerFormularioPublico(idmenu: number, idform: number, options?: RestOptions): RestResponse<ICuestionario> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/publ/_f/${idmenu}/${idform}`, options: options });
    }
}

export interface IApiRestGestionCurriculums {

    /**
     * HTTP POST /api/priv/_cv/cv/{idcv}/act
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevaAccionParaCV
     */
    nuevaAccionParaCV(idcv: number, accion: IAccionCV, options?: RestOptions): RestResponse<IResultadoAccionCV>;

    /**
     * HTTP POST /api/priv/_cv/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevoDocInternoParaCV
     */
    nuevoDocInternoParaCV(idcv: number, options?: RestOptions): RestResponse<IResultadoDocInternoCV>;

    /**
     * HTTP DELETE /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.borrarDocInterno
     */
    borrarDocInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<boolean>;

    /**
     * HTTP GET /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOCInterno
     */
    descargaDOCInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource>;

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerCv
     */
    leerCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteCV>;

    /**
     * HTTP PUT /api/priv/_cv/cv/{idform}/{idcv}/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.editarFormCV
     */
    editarFormCV(idform: number, idcv: number, edicion: ICurriculumRequestEdit, options?: RestOptions): RestResponse<ICurriculumState>;

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}/f
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerFormCv
     */
    leerFormCv(idform: number, idcv: number, options?: RestOptions): RestResponse<ICuestionarioForm>;

    /**
     * HTTP GET /api/priv/_cv/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.registroCv
     */
    registroCv(idcv: number, options?: RestOptions): RestResponse<IModelCurriculum>;

    /**
     * HTTP GET /api/priv/_cv/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOC
     */
    descargaDOC(tkn: string, uuidoc: string, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource>;

    /**
     * HTTP GET /api/priv/_cv/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculumsFormulario
     */
    pregsSeleccionCurriculumsFormulario(idform: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionarioFormulario>>;

    /**
     * HTTP GET /api/priv/_cv/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.valoresParaSeleccion
     */
    valoresParaSeleccion(idformular: number, idformq: number, idq: number, options?: RestOptions): RestResponse<IValoresBusqueda>;

    /**
     * HTTP GET /api/priv/_cv/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculums
     */
    pregsSeleccionCurriculums(idmen: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionario>>;

    /**
     * HTTP POST /api/priv/_cv/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.findCV
     */
    findCV(filtros: IFiltrosBusquedaCV, options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP GET /api/priv/_cv/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.opcionesSeleccionCurriculums
     */
    opcionesSeleccionCurriculums(options?: RestOptions): RestResponse<IOpcionesCurr>;

    /**
     * HTTP GET /api/priv/_cv/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.lastCV
     */
    lastCV(options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP POST /api/priv/_cv/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.listCV
     */
    listCV(filtros: IFiltrosUltimosCV, options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP GET /api/priv/_cv/regs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.regsCV
     */
    regsCV(queryParams: { num: number; pag: number; }, options?: RestOptions): RestResponse<IPage<IModelCurriculum>>;

    /**
     * HTTP GET /api/priv/_cv/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.totalCV
     */
    totalCV(options?: RestOptions): RestResponse<IResumenEstadosCV>;
}

export class IApiRestGestionCurriculumsClient implements IApiRestGestionCurriculums {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_cv/cv/{idcv}/act
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevaAccionParaCV
     */
    nuevaAccionParaCV(idcv: number, accion: IAccionCV, options?: RestOptions): RestResponse<IResultadoAccionCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cv/cv/${idcv}/act`, data: accion, options: options });
    }

    /**
     * HTTP POST /api/priv/_cv/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.nuevoDocInternoParaCV
     */
    nuevoDocInternoParaCV(idcv: number, options?: RestOptions): RestResponse<IResultadoDocInternoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cv/cv/${idcv}/idoc`, options: options });
    }

    /**
     * HTTP DELETE /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.borrarDocInterno
     */
    borrarDocInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/priv/_cv/cv/${idcv}/idoc/${iddoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOCInterno
     */
    descargaDOCInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/cv/${idcv}/idoc/${iddoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerCv
     */
    leerCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/cv/${idform}/${idcv}`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_cv/cv/{idform}/{idcv}/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.editarFormCV
     */
    editarFormCV(idform: number, idcv: number, edicion: ICurriculumRequestEdit, options?: RestOptions): RestResponse<ICurriculumState> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_cv/cv/${idform}/${idcv}/ed`, data: edicion, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/cv/{idform}/{idcv}/f
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.leerFormCv
     */
    leerFormCv(idform: number, idcv: number, options?: RestOptions): RestResponse<ICuestionarioForm> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/cv/${idform}/${idcv}/f`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.registroCv
     */
    registroCv(idcv: number, options?: RestOptions): RestResponse<IModelCurriculum> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/cvid/${idcv}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.descargaDOC
     */
    descargaDOC(tkn: string, uuidoc: string, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/doc/${tkn}/${uuidoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculumsFormulario
     */
    pregsSeleccionCurriculumsFormulario(idform: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionarioFormulario>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/f/f/${idform}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.valoresParaSeleccion
     */
    valoresParaSeleccion(idformular: number, idformq: number, idq: number, options?: RestOptions): RestResponse<IValoresBusqueda> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/f/${idformular}/${idformq}/${idq}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.pregsSeleccionCurriculums
     */
    pregsSeleccionCurriculums(idmen: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionario>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/f/${idmen}`, options: options });
    }

    /**
     * HTTP POST /api/priv/_cv/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.findCV
     */
    findCV(filtros: IFiltrosBusquedaCV, options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cv/find`, data: filtros, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.opcionesSeleccionCurriculums
     */
    opcionesSeleccionCurriculums(options?: RestOptions): RestResponse<IOpcionesCurr> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/forms`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.lastCV
     */
    lastCV(options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/last`, options: options });
    }

    /**
     * HTTP POST /api/priv/_cv/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.listCV
     */
    listCV(filtros: IFiltrosUltimosCV, options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cv/list`, data: filtros, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/regs
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.regsCV
     */
    regsCV(queryParams: { num: number; pag: number; }, options?: RestOptions): RestResponse<IPage<IModelCurriculum>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/regs`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_cv/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionCurriculums.totalCV
     */
    totalCV(options?: RestOptions): RestResponse<IResumenEstadosCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cv/total`, options: options });
    }
}

export interface IApiRestGestionFormsInternos {

    /**
     * HTTP POST /api/priv/_fi/cv/{idcv}/act
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevaAccionParaCV
     */
    nuevaAccionParaCV(idcv: number, accion: IAccionCV, options?: RestOptions): RestResponse<IResultadoAccionCV>;

    /**
     * HTTP POST /api/priv/_fi/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevoDocInternoParaCV
     */
    nuevoDocInternoParaCV(idcv: number, options?: RestOptions): RestResponse<IResultadoDocInternoCV>;

    /**
     * HTTP DELETE /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.borrarDocInterno
     */
    borrarDocInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<boolean>;

    /**
     * HTTP GET /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOCInterno
     */
    descargaDOCInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource>;

    /**
     * HTTP GET /api/priv/_fi/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.leerCv
     */
    leerCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteCV>;

    /**
     * HTTP GET /api/priv/_fi/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.registroCv
     */
    registroCv(idcv: number, options?: RestOptions): RestResponse<IModelCurriculum>;

    /**
     * HTTP GET /api/priv/_fi/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOC
     */
    descargaDOC(tkn: string, uuidoc: string, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource>;

    /**
     * HTTP GET /api/priv/_fi/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculumsFormulario
     */
    pregsSeleccionCurriculumsFormulario(idform: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionarioFormulario>>;

    /**
     * HTTP GET /api/priv/_fi/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.valoresParaSeleccion
     */
    valoresParaSeleccion(idformular: number, idformq: number, idq: number, options?: RestOptions): RestResponse<IValoresBusqueda>;

    /**
     * HTTP GET /api/priv/_fi/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculums
     */
    pregsSeleccionCurriculums(idmen: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionario>>;

    /**
     * HTTP POST /api/priv/_fi/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.findCV
     */
    findCV(filtros: IFiltrosBusquedaCV, options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP GET /api/priv/_fi/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.opcionesSeleccionCurriculums
     */
    opcionesSeleccionCurriculums(options?: RestOptions): RestResponse<IOpcionesCurr>;

    /**
     * HTTP GET /api/priv/_fi/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.lastCV
     */
    lastCV(options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP POST /api/priv/_fi/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.listCV
     */
    listCV(filtros: IFiltrosUltimosCV, options?: RestOptions): RestResponse<IListadoCV>;

    /**
     * HTTP GET /api/priv/_fi/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.totalCV
     */
    totalCV(options?: RestOptions): RestResponse<IResumenEstadosCV>;
}

export class IApiRestGestionFormsInternosClient implements IApiRestGestionFormsInternos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_fi/cv/{idcv}/act
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevaAccionParaCV
     */
    nuevaAccionParaCV(idcv: number, accion: IAccionCV, options?: RestOptions): RestResponse<IResultadoAccionCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_fi/cv/${idcv}/act`, data: accion, options: options });
    }

    /**
     * HTTP POST /api/priv/_fi/cv/{idcv}/idoc
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.nuevoDocInternoParaCV
     */
    nuevoDocInternoParaCV(idcv: number, options?: RestOptions): RestResponse<IResultadoDocInternoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_fi/cv/${idcv}/idoc`, options: options });
    }

    /**
     * HTTP DELETE /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.borrarDocInterno
     */
    borrarDocInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<boolean> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/priv/_fi/cv/${idcv}/idoc/${iddoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/cv/{idcv}/idoc/{iddoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOCInterno
     */
    descargaDOCInterno(idcv: number, iddoc: number, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/cv/${idcv}/idoc/${iddoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.leerCv
     */
    leerCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/cv/${idform}/${idcv}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/cvid/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.registroCv
     */
    registroCv(idcv: number, options?: RestOptions): RestResponse<IModelCurriculum> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/cvid/${idcv}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/doc/{tkn}/{uuidoc}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.descargaDOC
     */
    descargaDOC(tkn: string, uuidoc: string, queryParams: { f: string; }, options?: RestOptions): RestResponse<IInputStreamResource> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/doc/${tkn}/${uuidoc}`, queryParams: queryParams, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/f/f/{idform}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculumsFormulario
     */
    pregsSeleccionCurriculumsFormulario(idform: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionarioFormulario>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/f/f/${idform}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/f/{idformular}/{idformq}/{idq}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.valoresParaSeleccion
     */
    valoresParaSeleccion(idformular: number, idformq: number, idq: number, options?: RestOptions): RestResponse<IValoresBusqueda> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/f/${idformular}/${idformq}/${idq}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/f/{idmen}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.pregsSeleccionCurriculums
     */
    pregsSeleccionCurriculums(idmen: number, options?: RestOptions): RestResponse<IPregsBusqueda<ICuestionario>> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/f/${idmen}`, options: options });
    }

    /**
     * HTTP POST /api/priv/_fi/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.findCV
     */
    findCV(filtros: IFiltrosBusquedaCV, options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_fi/find`, data: filtros, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/forms
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.opcionesSeleccionCurriculums
     */
    opcionesSeleccionCurriculums(options?: RestOptions): RestResponse<IOpcionesCurr> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/forms`, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/last
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.lastCV
     */
    lastCV(options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/last`, options: options });
    }

    /**
     * HTTP POST /api/priv/_fi/list
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.listCV
     */
    listCV(filtros: IFiltrosUltimosCV, options?: RestOptions): RestResponse<IListadoCV> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_fi/list`, data: filtros, options: options });
    }

    /**
     * HTTP GET /api/priv/_fi/total
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionFormsInternos.totalCV
     */
    totalCV(options?: RestOptions): RestResponse<IResumenEstadosCV> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fi/total`, options: options });
    }
}

export interface IApiRestGestionMenu {

    /**
     * HTTP POST /api/priv/_m/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.nuevoMenu
     */
    nuevoMenu(alta: IMenuNavegacion, options?: RestOptions): RestResponse<IMenuNavegacion>;

    /**
     * HTTP GET /api/priv/_m/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.menusNavegacion
     */
    menusNavegacion(options?: RestOptions): RestResponse<INavegacion>;

    /**
     * HTTP GET /api/priv/_m/form
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.formulariosSeleccion
     */
    formulariosSeleccion(options?: RestOptions): RestResponse<IModelFormulario[]>;

    /**
     * HTTP PUT /api/priv/_m/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.actualizaMenu
     */
    actualizaMenu(alta: IMenuNavegacion, options?: RestOptions): RestResponse<IMenuNavegacion>;
}

export class IApiRestGestionMenuClient implements IApiRestGestionMenu {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_m/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.nuevoMenu
     */
    nuevoMenu(alta: IMenuNavegacion, options?: RestOptions): RestResponse<IMenuNavegacion> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_m/add`, data: alta, options: options });
    }

    /**
     * HTTP GET /api/priv/_m/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.menusNavegacion
     */
    menusNavegacion(options?: RestOptions): RestResponse<INavegacion> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_m/ed`, options: options });
    }

    /**
     * HTTP GET /api/priv/_m/form
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.formulariosSeleccion
     */
    formulariosSeleccion(options?: RestOptions): RestResponse<IModelFormulario[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_m/form`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_m/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionMenu.actualizaMenu
     */
    actualizaMenu(alta: IMenuNavegacion, options?: RestOptions): RestResponse<IMenuNavegacion> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_m/save`, data: alta, options: options });
    }
}

export interface IApiRestGestionTextos {

    /**
     * HTTP POST /api/priv/_t/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.nuevoTexto
     */
    nuevoTexto(alta: IGestionTexto, options?: RestOptions): RestResponse<IModelText[]>;

    /**
     * HTTP GET /api/priv/_t/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.textos
     */
    textos(options?: RestOptions): RestResponse<ITextosPorKey>;

    /**
     * HTTP PUT /api/priv/_t/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.actualizaTextos
     */
    actualizaTextos(alta: IGestionTexto, options?: RestOptions): RestResponse<IModelText[]>;
}

export class IApiRestGestionTextosClient implements IApiRestGestionTextos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP POST /api/priv/_t/add
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.nuevoTexto
     */
    nuevoTexto(alta: IGestionTexto, options?: RestOptions): RestResponse<IModelText[]> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_t/add`, data: alta, options: options });
    }

    /**
     * HTTP GET /api/priv/_t/ed
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.textos
     */
    textos(options?: RestOptions): RestResponse<ITextosPorKey> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_t/ed`, options: options });
    }

    /**
     * HTTP PUT /api/priv/_t/save
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestGestionTextos.actualizaTextos
     */
    actualizaTextos(alta: IGestionTexto, options?: RestOptions): RestResponse<IModelText[]> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/priv/_t/save`, data: alta, options: options });
    }
}

export interface IApiRestHistoricoCurriculums {

    /**
     * HTTP GET /api/priv/_cvhist/cv/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.datosCvHistorico
     */
    datosCvHistorico(idcv: number, options?: RestOptions): RestResponse<IReporteCVHistorico>;

    /**
     * HTTP GET /api/priv/_cvhist/cv/{idcv}/rel
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarHistoricosRelacionados
     */
    buscarHistoricosRelacionados(idcv: number, options?: RestOptions): RestResponse<IRespuestasHistRelacionadas>;

    /**
     * HTTP DELETE /api/priv/_cvhist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.borrarCv
     */
    borrarCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteBorradoCV>;

    /**
     * HTTP POST /api/priv/_cvhist/cv_rel_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarCoincidenciasHistorico
     */
    buscarCoincidenciasHistorico(peticion: IPeticionCoincidencias, options?: RestOptions): RestResponse<IRespuestasHistRelacionadas[]>;

    /**
     * HTTP POST /api/priv/_cvhist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.listCV
     */
    listCV(filtros: IFiltrosHistorico, options?: RestOptions): RestResponse<IListadoHistorico>;

    /**
     * HTTP GET /api/priv/_cvhist/regs_pend
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.regsCVPendientesHist
     */
    regsCVPendientesHist(options?: RestOptions): RestResponse<IModelCurriculum[]>;

    /**
     * HTTP GET /api/priv/_cvhist/resp_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.respuestasHistorico
     */
    respuestasHistorico(options?: RestOptions): RestResponse<IRespuestasEnHistorico>;
}

export class IApiRestHistoricoCurriculumsClient implements IApiRestHistoricoCurriculums {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_cvhist/cv/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.datosCvHistorico
     */
    datosCvHistorico(idcv: number, options?: RestOptions): RestResponse<IReporteCVHistorico> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cvhist/cv/${idcv}`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cvhist/cv/{idcv}/rel
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarHistoricosRelacionados
     */
    buscarHistoricosRelacionados(idcv: number, options?: RestOptions): RestResponse<IRespuestasHistRelacionadas> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cvhist/cv/${idcv}/rel`, options: options });
    }

    /**
     * HTTP DELETE /api/priv/_cvhist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.borrarCv
     */
    borrarCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteBorradoCV> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/priv/_cvhist/cv/${idform}/${idcv}`, options: options });
    }

    /**
     * HTTP POST /api/priv/_cvhist/cv_rel_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.buscarCoincidenciasHistorico
     */
    buscarCoincidenciasHistorico(peticion: IPeticionCoincidencias, options?: RestOptions): RestResponse<IRespuestasHistRelacionadas[]> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cvhist/cv_rel_hist`, data: peticion, options: options });
    }

    /**
     * HTTP POST /api/priv/_cvhist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.listCV
     */
    listCV(filtros: IFiltrosHistorico, options?: RestOptions): RestResponse<IListadoHistorico> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_cvhist/find`, data: filtros, options: options });
    }

    /**
     * HTTP GET /api/priv/_cvhist/regs_pend
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.regsCVPendientesHist
     */
    regsCVPendientesHist(options?: RestOptions): RestResponse<IModelCurriculum[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cvhist/regs_pend`, options: options });
    }

    /**
     * HTTP GET /api/priv/_cvhist/resp_hist
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoCurriculums.respuestasHistorico
     */
    respuestasHistorico(options?: RestOptions): RestResponse<IRespuestasEnHistorico> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_cvhist/resp_hist`, options: options });
    }
}

export interface IApiRestHistoricoFormsInternos {

    /**
     * HTTP GET /api/priv/_fihist/cv/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.datosCvHistorico
     */
    datosCvHistorico(idcv: number, options?: RestOptions): RestResponse<IReporteCVHistorico>;

    /**
     * HTTP DELETE /api/priv/_fihist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.borrarCv
     */
    borrarCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteBorradoCV>;

    /**
     * HTTP POST /api/priv/_fihist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.listCV
     */
    listCV(filtros: IFiltrosHistorico, options?: RestOptions): RestResponse<IListadoHistorico>;
}

export class IApiRestHistoricoFormsInternosClient implements IApiRestHistoricoFormsInternos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_fihist/cv/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.datosCvHistorico
     */
    datosCvHistorico(idcv: number, options?: RestOptions): RestResponse<IReporteCVHistorico> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_fihist/cv/${idcv}`, options: options });
    }

    /**
     * HTTP DELETE /api/priv/_fihist/cv/{idform}/{idcv}
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.borrarCv
     */
    borrarCv(idform: number, idcv: number, options?: RestOptions): RestResponse<IReporteBorradoCV> {
        return this.httpClient.request({ method: "DELETE", url: uriEncoding`api/priv/_fihist/cv/${idform}/${idcv}`, options: options });
    }

    /**
     * HTTP POST /api/priv/_fihist/find
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestHistoricoFormsInternos.listCV
     */
    listCV(filtros: IFiltrosHistorico, options?: RestOptions): RestResponse<IListadoHistorico> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_fihist/find`, data: filtros, options: options });
    }
}

export interface IApiRestLogin {

    /**
     * HTTP GET /api/priv/_w/_auth
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.authDetails
     */
    authDetails(options?: RestOptions): RestResponse<any>;

    /**
     * HTTP GET /api/priv/_w/_logout
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.logout
     */
    logout(options?: RestOptions): RestResponse<string>;

    /**
     * HTTP POST /api/priv/_w/login
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.login
     */
    login(login: ILoginPet, options?: RestOptions): RestResponse<IAppState>;

    /**
     * HTTP GET /api/priv/_w/whoami
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetails
     */
    userDetails(options?: RestOptions): RestResponse<IAppState>;

    /**
     * HTTP GET /api/priv/_w/whoamicfg
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetailsConConfig
     */
    userDetailsConConfig(options?: RestOptions): RestResponse<IAppStateConfig>;
}

export class IApiRestLoginClient implements IApiRestLogin {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_w/_auth
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.authDetails
     */
    authDetails(options?: RestOptions): RestResponse<any> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_w/_auth`, options: options });
    }

    /**
     * HTTP GET /api/priv/_w/_logout
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.logout
     */
    logout(options?: RestOptions): RestResponse<string> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_w/_logout`, options: options });
    }

    /**
     * HTTP POST /api/priv/_w/login
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.login
     */
    login(login: ILoginPet, options?: RestOptions): RestResponse<IAppState> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/priv/_w/login`, data: login, options: options });
    }

    /**
     * HTTP GET /api/priv/_w/whoami
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetails
     */
    userDetails(options?: RestOptions): RestResponse<IAppState> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_w/whoami`, options: options });
    }

    /**
     * HTTP GET /api/priv/_w/whoamicfg
     * Java method: com.caxtoncollege.candidato.webapp.gestion.ApiRestLogin.userDetailsConConfig
     */
    userDetailsConConfig(options?: RestOptions): RestResponse<IAppStateConfig> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_w/whoamicfg`, options: options });
    }
}

export interface IApiRestMainQuestions {

    /**
     * HTTP PUT /api/_mq/ed/e/{idmq}/mod_mq
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.editarPregPrincipal
     */
    editarPregPrincipal(idmq: number, data: IMainQuestionEdit, options?: RestOptions): RestResponse<IFilaMainQuestion>;

    /**
     * HTTP POST /api/_mq/ed/n/n_mq
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.altaPregPrincipal
     */
    altaPregPrincipal(data: IMainQuestionEdit, options?: RestOptions): RestResponse<IFilaMainQuestion>;

    /**
     * HTTP GET /api/_mq/get/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.leerPregPrincipal
     */
    leerPregPrincipal(idmq: number, options?: RestOptions): RestResponse<IFilaMainQuestion>;

    /**
     * HTTP GET /api/_mq/l
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipales
     */
    todasLasPregPrincipales(options?: RestOptions): RestResponse<IModelMainQuestion[]>;

    /**
     * HTTP GET /api/_mq/ll
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipalesConPreg
     */
    todasLasPregPrincipalesConPreg(options?: RestOptions): RestResponse<IFilaMainQuestion[]>;

    /**
     * HTTP GET /api/_mq/mq_uses/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.usosPregPrincipal
     */
    usosPregPrincipal(idmq: number, options?: RestOptions): RestResponse<IPregConParentProjection[]>;
}

export class IApiRestMainQuestionsClient implements IApiRestMainQuestions {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP PUT /api/_mq/ed/e/{idmq}/mod_mq
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.editarPregPrincipal
     */
    editarPregPrincipal(idmq: number, data: IMainQuestionEdit, options?: RestOptions): RestResponse<IFilaMainQuestion> {
        return this.httpClient.request({ method: "PUT", url: uriEncoding`api/_mq/ed/e/${idmq}/mod_mq`, data: data, options: options });
    }

    /**
     * HTTP POST /api/_mq/ed/n/n_mq
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.altaPregPrincipal
     */
    altaPregPrincipal(data: IMainQuestionEdit, options?: RestOptions): RestResponse<IFilaMainQuestion> {
        return this.httpClient.request({ method: "POST", url: uriEncoding`api/_mq/ed/n/n_mq`, data: data, options: options });
    }

    /**
     * HTTP GET /api/_mq/get/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.leerPregPrincipal
     */
    leerPregPrincipal(idmq: number, options?: RestOptions): RestResponse<IFilaMainQuestion> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/_mq/get/${idmq}`, options: options });
    }

    /**
     * HTTP GET /api/_mq/l
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipales
     */
    todasLasPregPrincipales(options?: RestOptions): RestResponse<IModelMainQuestion[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/_mq/l`, options: options });
    }

    /**
     * HTTP GET /api/_mq/ll
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.todasLasPregPrincipalesConPreg
     */
    todasLasPregPrincipalesConPreg(options?: RestOptions): RestResponse<IFilaMainQuestion[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/_mq/ll`, options: options });
    }

    /**
     * HTTP GET /api/_mq/mq_uses/{idmq}
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMainQuestions.usosPregPrincipal
     */
    usosPregPrincipal(idmq: number, options?: RestOptions): RestResponse<IPregConParentProjection[]> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/_mq/mq_uses/${idmq}`, options: options });
    }
}

export interface IApiRestMenu {

    /**
     * HTTP GET /api/priv/_m/start
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicio
     */
    menuInicio(options?: RestOptions): RestResponse<ISeleccionMenu>;

    /**
     * HTTP GET /api/priv/_m/startcfg
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfig
     */
    menuInicioConfig(options?: RestOptions): RestResponse<IAppStart>;

    /**
     * HTTP GET /api/priv/_m/startcfg/priv
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfigMenusPrivados
     */
    menuInicioConfigMenusPrivados(options?: RestOptions): RestResponse<IAppStart>;
}

export class IApiRestMenuClient implements IApiRestMenu {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/priv/_m/start
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicio
     */
    menuInicio(options?: RestOptions): RestResponse<ISeleccionMenu> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_m/start`, options: options });
    }

    /**
     * HTTP GET /api/priv/_m/startcfg
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfig
     */
    menuInicioConfig(options?: RestOptions): RestResponse<IAppStart> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_m/startcfg`, options: options });
    }

    /**
     * HTTP GET /api/priv/_m/startcfg/priv
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenu.menuInicioConfigMenusPrivados
     */
    menuInicioConfigMenusPrivados(options?: RestOptions): RestResponse<IAppStart> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/priv/_m/startcfg/priv`, options: options });
    }
}

export interface IApiRestMenuPublicos {

    /**
     * HTTP GET /api/publ/_m/startcfg/publ
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenuPublicos.menuInicioConfigMenusPublicos
     */
    menuInicioConfigMenusPublicos(options?: RestOptions): RestResponse<IAppStart>;
}

export class IApiRestMenuPublicosClient implements IApiRestMenuPublicos {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/publ/_m/startcfg/publ
     * Java method: com.caxtoncollege.candidato.webapp.curr.ApiRestMenuPublicos.menuInicioConfigMenusPublicos
     */
    menuInicioConfigMenusPublicos(options?: RestOptions): RestResponse<IAppStart> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/publ/_m/startcfg/publ`, options: options });
    }
}

export interface IApiRestView {

    /**
     * HTTP GET /api/view/auth
     * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails
     */
    userDetails(options?: RestOptions): RestResponse<IAppState>;

    /**
     * HTTP GET /api/view/cv
     * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails2
     */
    userDetails2(options?: RestOptions): RestResponse<IAppState>;
}

export class IApiRestViewClient implements IApiRestView {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * HTTP GET /api/view/auth
     * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails
     */
    userDetails(options?: RestOptions): RestResponse<IAppState> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/view/auth`, options: options });
    }

    /**
     * HTTP GET /api/view/cv
     * Java method: com.caxtoncollege.candidato.webapp.view.ApiRestView.userDetails2
     */
    userDetails2(options?: RestOptions): RestResponse<IAppState> {
        return this.httpClient.request({ method: "GET", url: uriEncoding`api/view/cv`, options: options });
    }
}

export interface IAbstractResource extends IResource {
}

export interface IAccionCV {
    dataNotif: IAccionCvDataNotif;
    notas: string;
    state: IModelEstadoCv;
}

export interface IAccionCvDataNotif {
    comite_autoriza: string;
    comite_puesto: string;
}

export interface IAnnotatedElement {
    annotations: IAnnotation[];
    declaredAnnotations: IAnnotation[];
}

export interface IAnnotatedType extends IAnnotatedElement {
    annotatedOwnerType: IAnnotatedType;
    type: IType;
}

export interface IAnnotation {
}

export interface IAppStart {
    appconfig: IFeaturesPubl;
    options: ISeleccionMenu;
}

export interface IAppState {
    adm: boolean;
    username: string;
}

export interface IAppStateConfig extends IAppState {
    options: IFeaturesPriv;
}

export interface IAtomicBoolean extends ISerializable {
}

export interface IAutoCloseable {
}

export interface IBaseStream<T, S> extends IAutoCloseable {
    parallel: boolean;
}

export interface IBeanPath<T> extends ISimpleExpression<T>, IPath<T> {
}

export interface IBloqueCV {
    bloque: IModelBloque;
    pregsList: IPreguntaCV[];
    vacio: boolean;
}

export interface IBooleanExpression extends ILiteralExpression<boolean>, IPredicate {
}

export interface IBooleanPath extends IBooleanExpression, IPath<boolean> {
}

export interface IBusquedaCV extends IBusquedaCVBase<IFiltrosBusquedaCV> {
    filtros: IFiltrosBusquedaCV;
}

export interface IBusquedaCVBase<T> extends IIBusquedaExecutor<IModelCurriculum> {
    filtros: T;
}

export interface IBusquedaRespuestas extends IIBusquedaExecutor<IModelRespuesta> {
    idsPreg: number[];
    idscvs: number[];
}

export interface ICVHistoricoBusqueda extends IComparable<ICVHistoricoBusqueda> {
    curr: IModelCurriculumHistoric;
    porPreg: { [index: string]: IRespHistorico };
}

export interface ICVReq {
    idform: number;
}

export interface ICVReqAlta extends ICVReq {
    idmen: number;
}

export interface ICVReqEdit extends ICVReq {
    idcv: number;
}

export interface ICambioEstadoDoc {
    mails: string[];
    st: IModelEstadoCv;
}

export interface IClass<T> extends ISerializable, IGenericDeclaration, IType, IAnnotatedElement {
}

export interface ICloseable extends IAutoCloseable {
}

export interface ICoincidenciaHistorico {
    coincidencias: IPair<IFilaRespuestaCV, IModelRespuesta>[];
    pregCv: IPreguntaCV;
    pregFila: IPreguntaCV;
}

export interface ICoincidenciasHistBase<T> {
    registrosHistPorPreg: { [index: string]: T };
    registrosHistSinPreg: IModelRespuestaHistCV[];
    tieneMatch: boolean;
}

export interface ICoincidenciasHistCV<T> extends ICoincidenciasHistBase<T> {
}

export interface ICoincidenciasHistEnCv extends ICoincidenciasHistCV<IRegistrosCoincidenciasPreg> {
    registrosHistPorPreg: { [index: string]: IRegistrosCoincidenciasPreg };
}

export interface IColCV {
    r: IModelRespuesta;
}

export interface IComparable<T> {
}

export interface IComparableExpression<T> extends IComparableExpressionBase<T> {
}

export interface IComparableExpressionBase<T> extends ISimpleExpression<T> {
}

export interface ICondicionBusqueda {
    cond_bool: boolean;
    cond_fin: Date;
    cond_ini: Date;
    cond_max: number;
    cond_min: number;
    cond_opt: string[];
    cond_txt: string;
    cv_estado: string;
    cv_fin: Date;
    cv_ini: Date;
    idq: number;
    incluir: boolean;
    tipocondicion: ITipoCondicionBusqueda;
}

export interface IContieneRespuestas {
    respuestas: IModelRespuesta[];
}

export interface ICuestBloque extends IICuestionarioBloque<ICuestionarioPreg> {
    qlist: ICuestionarioPreg[];
    v2: boolean;
}

export interface ICuestionario extends ICuestionarioFormulario {
    infoForm: ISeleccionForm;
}

export interface ICuestionario2 extends ICuestionarioForm {
    infoForm: ISeleccionForm;
}

export interface ICuestionarioBloque extends IICuestionarioBloque<ICuestionarioPreg> {
    qlist: ICuestionarioPreg[];
}

export interface ICuestionarioForm extends IICuestionario<ICuestBloque> {
    blist: ICuestBloque[];
}

export interface ICuestionarioFormulario extends IICuestionario<ICuestionarioBloque> {
    blist: ICuestionarioBloque[];
}

export interface ICuestionarioPreg extends IICuestionarioPreg {
}

export interface ICurriculumRequestAlta extends ICurriculumRequestBase<ICVReqAlta, IQResp> {
    peticion: ICVReqAlta;
    resplist: IQResp[];
}

export interface ICurriculumRequestBase<R, Q> extends IIVerificaReq {
    peticion: R;
    resplist: Q[];
    verify: string;
}

export interface ICurriculumRequestEdit extends ICurriculumRequestBase<ICVReqEdit, IQRespEdit> {
    peticion: ICVReqEdit;
    resplist: IQRespEdit[];
}

export interface ICurriculumState {
    _t: string;
    ok: boolean;
    tkn: string;
}

export interface IDateTimeExpression<T> extends ITemporalExpression<T> {
}

export interface IDateTimePath<T> extends IDateTimeExpression<T>, IPath<T> {
}

export interface IDocsInternosCV {
    list: IModelDocInterno[];
}

export interface IDslExpression<T> extends IExpression<T> {
}

export interface IEdicionForm {
    data: IModelFormulario;
}

export interface IEdicionFormularios {
    list: IEdicionForm[];
    preguntas: IListaPreguntas;
}

export interface IEdicionPregunta {
    data: IModelPregunta;
    eliminar: boolean;
    f: IModelFilaPreg;
    subp: IEdicionPregunta[];
}

export interface IEdicionPreguntas {
    list: IEdicionPregunta[];
    pregs: { [index: string]: IEdicionPregunta };
}

export interface IEntityPath<T> extends IPath<T> {
}

export interface IEntityPathBase<T> extends IBeanPath<T>, IEntityPath<T> {
}

export interface IEstadoCvNotifStore {
    data: { [index: string]: IEstadoCvNotifStoreItem };
    list: IEstadoCvNotifStoreItem[];
}

export interface IEstadoCvNotifStoreItem {
    estado: IModelEstadoCv;
    estadoComite: boolean;
    mailsNotifi: string;
    notificar: boolean;
}

export interface IEstadoCvStore {
    data: { [index: string]: IEstadoCvStoreItem };
    list: IEstadoCvStoreItem[];
}

export interface IEstadoCvStoreItem {
    estado: IModelEstadoCv;
    estadoComite: boolean;
}

export interface IExpression<T> extends ISerializable {
    type: IClass<T>;
}

export interface IFeaturesPriv {
    app: ICandidatoApp;
    dmesg: boolean;
    introCv: boolean;
    pageTitle: string;
    perfilAdmin: boolean;
}

export interface IFeaturesPubl {
    acceptRecaptcha: boolean;
    acceptTerms: boolean;
    app: ICandidatoApp;
    dmesg: boolean;
    introCv: boolean;
}

export interface IFilaCV {
    cols: IColCV[][];
    cv: IModelCurriculum;
    form: IModelFormulario;
    menu: IModelMenu;
    permiteEdit: boolean;
    respHist: ICoincidenciasHistCV<any>;
}

export interface IFilaMainQuestion {
    mq: IModelMainQuestion;
}

export interface IFilaRespuestaCV {
    ff: IModelFichero;
    rr: IModelRespuesta;
}

export interface IFile extends ISerializable, IComparable<IFile> {
}

export interface IFiltrosBusquedaCV extends IIFiltrosBuscarCV {
    estado: string;
    idcv: number;
    idform: number;
    idmen: number;
    listarPublicos: boolean;
    usuarioGestor: string;
    w: ICondicionBusqueda[];
}

export interface IFiltrosHistorico extends IIFiltrosBuscarCV {
    estado: string;
    idcvhist: number;
    limit: number;
    q_value: string;
    usuarioGestor: string;
}

export interface IFiltrosUltimosCV extends IIFiltrosBuscarCV {
    end: Date;
    estado: string;
    idcv: number;
    limit: number;
    listarPublicos: boolean;
    mainq: number;
    q_value: string;
    start: Date;
    usuarioGestor: string;
}

export interface IFormBloque {
    data: IModelBloque;
    eliminar: boolean;
    pregsList: IFormPregunta[];
    restaurar: boolean;
}

export interface IFormCompleto {
    bloques: IFormBloque[];
    data: IModelFormulario;
}

export interface IFormPregunta {
    data: IModelPreguntaForm;
    eliminar: boolean;
    q: IModelPregunta;
}

export interface IFormularioEnCV {
    consumido: IAtomicBoolean;
    formValid: boolean;
    permiteDocs: boolean;
    resp_huerfanas: IModelRespuesta[];
}

export interface IGenericDeclaration extends IAnnotatedElement {
    typeParameters: ITypeVariable<any>[];
}

export interface IGestionEstado {
    estado: string;
    mails: IModelNotificacionEstado[];
    st: IModelEstadoCv;
}

export interface IGestionEstadosDoc {
    estados: { [index: string]: IGestionEstado };
    list: IGestionEstado[];
    sinestado: IModelNotificacionEstado[];
}

export interface IGestionReglasNotifDoc {
    estados: IEstadoCvStore;
    reglas: IModelNotificacionDoc[];
    tiposdocs: ITiposDocumento;
}

export interface IGestionReglasValidacionDoc {
    estados: IEstadoCvStore;
    forms: IModelFormulario[];
    reglasVal: IModelDocReq[];
    tiposdocs: ITiposDocumento;
}

export interface IGestionTexto {
    registros: IModelText[];
}

export interface IGrupoPreguntas {
    grupo: string;
    list: IModelPregunta[];
}

export interface IGrupoTipoDoc {
    label: string;
    tipos: IModelTipoDoc[];
}

export interface IHistoriaCV {
    list: IModelAccion[];
}

export interface IIBusquedaExecutor<T> {
}

export interface IIColumnasCV<T> {
    cols: T[];
}

export interface IICuestionario<T> {
    blist: T[];
    infoForm: IInfoFormular;
}

export interface IICuestionarioBloque<P> {
    qlist: P[];
    t: string;
}

export interface IICuestionarioPreg {
    allowOthers: boolean;
    blk: boolean;
    explain: string;
    includeDetails: boolean;
    max: number;
    maxOthers: number;
    mult: boolean;
    noq: boolean;
    opts: string[];
    q: string;
    qref: string;
    req: boolean;
    reqMsg: string;
    subp: IICuestionarioPreg[];
    tq: ITipoQ;
    vw: string;
    yndet: boolean;
    yndetReq: boolean;
}

export interface IIFiltrosBuscarCV {
}

export interface IIItemMenu {
}

export interface IIModel extends IIProjection {
}

export interface IIModelGrouping extends IIModel {
}

export interface IIProjection {
}

export interface IIVerificaReq {
}

export interface IInfoFormular {
    idf: number;
    t: string;
    tf: string;
    tp: string;
}

export interface IInputStream extends ICloseable {
}

export interface IInputStreamResource extends IAbstractResource {
}

export interface IInputStreamSource {
    inputStream: IInputStream;
}

export interface IItemMenu extends IIItemMenu {
    accLo: boolean;
    accRc: boolean;
    idf: number;
    idm: number;
    l: IItemMenu[];
    t: string;
    tf: string;
}

export interface IIterable<T> {
}

export interface IListaPreguntas {
    grupos: { [index: string]: IGrupoPreguntas };
    noSelectable: IModelPregunta[];
}

export interface IListaRespuestasBase<T> {
    respuestas: { [index: string]: T };
}

export interface IListaRespuestasCV extends IListaRespuestasBase<IRespuestasDePreg> {
    respuestas: { [index: string]: IRespuestasDePreg };
}

export interface IListadoCV {
    busquedacv: IBusquedaCV;
    busquedarespuestas: IBusquedaRespuestas;
    cols: IIColumnasCV<any>;
    list: IFilaCV[];
}

export interface IListadoHistorico {
    cvList: ICVHistoricoBusqueda[];
    filtros: IFiltrosHistorico;
}

export interface ILiteralExpression<T> extends IComparableExpression<T> {
}

export interface ILoginPet extends IIVerificaReq {
    ip: string;
    pass: string;
    username: string;
    verify: string;
}

export interface IMainQuestionEdit {
    mq: IModelMainQuestion;
}

export interface IMenuNavegacion extends IIItemMenu {
    forms: IMenuNavegacion[];
    m: IModelMenu;
}

export interface IModelAccion extends IIModel {
    cv_id: number;
    cv_id_historic: number;
    data: string;
    fc: Date;
    idaction: number;
    notificacion: string;
    obvs: string;
    state: string;
    who: string;
}

export interface IModelAccion_ {
}

export interface IModelAvisoCv extends IIModel {
    destino: Date;
    fcaviso: Date;
    idcv: number;
    idcvaviso: number;
    tipoaviso: string;
}

export interface IModelAvisoCv_ {
}

export interface IModelBloque extends IIModelGrouping {
    descr: string;
    formular_id: number;
    idbloq: number;
    noactivo: boolean;
    orden: number;
    texto_en: string;
    texto_id: number;
}

export interface IModelBloque_ {
}

export interface IModelCurriculum extends IIModelGrouping {
    comite_autoriza: string;
    comite_puesto: string;
    estado: string;
    fcalta: Date;
    fcenvio: Date;
    fcrevision: Date;
    form_id: number;
    idcv: number;
    ip: string;
    menu_id: number;
    revisor: string;
    tkn: string;
    usualta: string;
}

export interface IModelCurriculumEdit extends IIModelGrouping {
    fcedit: Date;
    idcv: number;
    idcvedit: number;
    tipo: string;
    usuedit: string;
}

export interface IModelCurriculumEdit_ {
}

export interface IModelCurriculumHistoric extends IIModelGrouping {
    cvuuid: string;
    estado: string;
    fcalta: Date;
    fcenvio: Date;
    fchist: Date;
    fcrevision: Date;
    form_id: number;
    idcv_orig: number;
    idcvhist: number;
    menu_id: number;
    revisor: string;
    tkn: string;
    usualta: string;
    usuhist: string;
}

export interface IModelCurriculumHistoric_ {
}

export interface IModelCurriculum_ {
}

export interface IModelDocInterno extends IIModel {
    cv_id: number;
    fc: Date;
    iddocint: number;
    name: string;
    obvs: string;
    path: string;
    tipo: string;
    who: string;
}

export interface IModelDocInterno_ {
}

export interface IModelDocReq extends IIModel {
    cond_bool: boolean;
    cond_fin: Date;
    cond_ini: Date;
    cond_max: number;
    cond_min: number;
    cond_opt: string;
    cond_txt: string;
    estado: string;
    idform: number;
    idquestion: number;
    idreqdoc: number;
    tipodoc: string;
}

export interface IModelDocReqBuilder {
}

export interface IModelDocReq_ {
}

export interface IModelEstadoCv extends IIModel {
    activanotif: boolean;
    asuntonotif: string;
    contartotal: boolean;
    estado: string;
    idestado: number;
    notas: string;
    orden: number;
    seleccionable: boolean;
    templatenotif: string;
    texto_en: string;
    texto_es: string;
    tiponotif: string;
}

export interface IModelEstadoCvBuilder {
}

export interface IModelEstadoCv_ {
}

export interface IModelFichero extends IIModel {
    cv_id: number;
    filename: string;
    idfile: number;
    path: string;
    q_id: number;
    resp_id: number;
}

export interface IModelFichero_ {
}

export interface IModelFilaPreg extends IIModel {
    idfilapreg: number;
    orden: number;
    quest_id: number;
    super_id: number;
    texto_en: string;
    texto_id: number;
    valida: boolean;
}

export interface IModelFilaPreg_ {
}

export interface IModelFormulario extends IIModel {
    formorigen: number;
    idform: number;
    noDocs: boolean;
    orden: number;
    texto_en: string;
    texto_id: number;
}

export interface IModelFormulario_ {
}

export interface IModelMainQuestion extends IIModelGrouping {
    descr: string;
    idmainq: number;
    noactivo: boolean;
    orden: number;
    qkey: string;
    texto_en: string;
    usar_busquedas: boolean;
    usar_listado: boolean;
}

export interface IModelMainQuestion_ {
}

export interface IModelMenu extends IIModel, IIItemMenu {
    acceso_publico: boolean;
    aceptar_captcha: boolean;
    aceptar_terminos_lopd: boolean;
    activo: boolean;
    formular_id: number;
    idmen: number;
    idmensuper: number;
    obvs: string;
    orden: number;
    seleccionable: boolean;
    texto_en: string;
    texto_id: number;
}

export interface IModelMenu_ {
}

export interface IModelNotificacionDoc extends IIModel {
    activanotif: boolean;
    asunto: string;
    estado: string;
    idnotifdoc: number;
    mail: string;
    tipodoc: string;
    todosdocs: boolean;
}

export interface IModelNotificacionDocBuilder {
}

export interface IModelNotificacionDoc_ {
}

export interface IModelNotificacionEstado extends IIModel {
    activanotif: boolean;
    estado: string;
    idnotifestado: number;
    mail: string;
}

export interface IModelNotificacionEstadoBuilder {
}

export interface IModelNotificacionEstado_ {
}

export interface IModelOpt extends IIModel {
    idopt: number;
    orden: number;
    pregform_id: number;
    texto_en: string;
    texto_id: number;
}

export interface IModelOpt_ {
}

export interface IModelPregSelect extends IIModel {
    idpregselect: number;
    orden: number;
    preg_id: number;
    texto_en: string;
    texto_id: number;
}

export interface IModelPregSelect_ {
}

export interface IModelPregunta extends IIModelGrouping {
    allow_other: boolean;
    block: boolean;
    buscar: boolean;
    details: boolean;
    details_req: boolean;
    explanation: string;
    exportar: boolean;
    grupo: string;
    idquest: number;
    keep_history: boolean;
    listado: boolean;
    mainq_id: number;
    multiple: boolean;
    notitle: boolean;
    omit_history_match: boolean;
    options: string;
    orden: number;
    others_max: number;
    qkey: string;
    required: boolean;
    requiredmsg: string;
    seleccionable: boolean;
    subpreg: boolean;
    texto_en: string;
    texto_id: number;
    tipoq: string;
    vista: string;
}

export interface IModelPreguntaForm extends IIModel {
    activo: boolean;
    allow_obvs: boolean;
    allow_other: boolean;
    bloque_id: number;
    formular_id: number;
    idformq: number;
    obvsmsg: string;
    options: string;
    orden: number;
    others_max: number;
    quest_id: number;
    required: boolean;
    requiredmsg: string;
    visibleEnForm: boolean;
}

export interface IModelPreguntaForm_ {
}

export interface IModelPregunta_ {
}

export interface IModelRespuesta extends IIModelGrouping {
    cv_id: number;
    cv_id_historic: number;
    fc: Date;
    idcvedit: number;
    idresp: number;
    idresp_sust: number;
    idx: number;
    optidx: number;
    q_id: number;
    resp_actual: boolean;
    resp_bool: boolean;
    resp_fec: Date;
    resp_fil: string;
    resp_id: number;
    resp_num: number;
    resp_obvs: string;
    resp_opt: string;
    resp_txt: string;
    resp_yndet: string;
    supq_id: number;
    tipo: string;
    valida: boolean;
}

export interface IModelRespuestaHistCV extends IIModel {
    cv_id: number;
    cv_id_historic: number;
    fcenlace: Date;
    idcvresphist: number;
    mainq_id: number;
    q_id: number;
    resp_id: number;
    resp_id_hist: number;
    supq_id: number;
    tiporesp: string;
    valor_cv: string;
    valor_hist: string;
}

export interface IModelRespuestaHistCV_ {
}

export interface IModelRespuesta_ {
}

export interface IModelText {
    idref: number;
    idtext: number;
    text: string;
    textkey: string;
    textlng: string;
}

export interface IModelText_ {
}

export interface IModelTipoDoc extends IIModel {
    grupo: string;
    idtipo: number;
    notas: string;
    orden: number;
    required: boolean;
    seleccionable: boolean;
    texto_en: string;
    texto_es: string;
    tipo: string;
}

export interface IModelTipoDoc_ {
}

export interface IModelToken extends IIModel {
    id: number;
    rnd: number;
    uuid: string;
}

export interface IModelToken_ {
}

export interface IModelVUsuariosPP extends IIModel {
    activogestor: boolean;
    buzongestor: string;
    coddep: string;
    codseccion: string;
    iddep: number;
    idfunc: number;
    idgestor: number;
    idseccion: number;
    langgestor: string;
    nomdep: string;
    nomgestor: string;
    nomseccion: string;
    pass_gestor: string;
    user_gestor: string;
}

export interface IModelVUsuariosPP_ {
}

export interface INavegacion {
    formularios: INavegacionForm[];
    menus: { [index: string]: IMenuNavegacion };
    root: IMenuNavegacion[];
}

export interface INavegacionForm {
    idform: number;
    texto_en: string;
}

export interface INumberExpression<T> extends IComparableExpressionBase<T> {
}

export interface INumberPath<T> extends INumberExpression<T>, IPath<T> {
}

export interface IOpcionCurr {
    item: IItemMenu;
    title: string;
}

export interface IOpcionesCurr extends ISeleccionMenu {
    listaSelecciones: IOpcionCurr[];
}

export interface IOrder extends ISerializable {
    ascending: boolean;
    descending: boolean;
    direction: IDirection;
    ignoreCase: boolean;
    nullHandling: INullHandling;
    property: string;
}

export interface IPage<T> extends ISlice<T> {
    totalElements: number;
    totalPages: number;
}

export interface IPageable {
    offset: number;
    pageNumber: number;
    pageSize: number;
    paged: boolean;
    sort: ISort;
    unpaged: boolean;
}

export interface IPair<S, T> {
    first: S;
    second: T;
}

export interface IPath<T> extends IExpression<T> {
    annotatedElement: IAnnotatedElement;
    metadata: IPathMetadata;
    root: IPath<any>;
}

export interface IPathMetadata extends ISerializable {
    element: any;
    name: string;
    parent: IPath<any>;
    pathType: IPathType;
    root: boolean;
    rootPath: IPath<any>;
}

export interface IPeticionCoincidencias {
    idsCv: number[];
    limit: number;
    seleccion: ISeleccionPeticionCoincidencias;
}

export interface IPredicate extends IExpression<boolean> {
}

export interface IPregBusqueda {
    p: ICuestionarioPreg;
    q: IModelPregunta;
    qf: IModelPreguntaForm;
    t: ITipoCondicion;
    title: string;
}

export interface IPregCompleto {
    data: IModelPregunta;
    filas: { [index: string]: IModelFilaPreg };
    subp: IEdicionPregunta[];
}

export interface IPregConParentProjection {
    parent: IModelPregunta;
    preg: IModelPregunta;
    pregFila: IModelFilaPreg;
}

export interface IPregsBusqueda<T> {
    form: T;
    listPreguntas: IPregBusqueda[];
}

export interface IPreguntaCV {
    activoActual: boolean;
    esFila: boolean;
    idformq: number;
    notPresent: boolean;
    notSelectable: boolean;
    notVisible: boolean;
    q: IModelPregunta;
    respuestas: IRespuestaCV[];
    seleccionableActual: boolean;
    skipNotPresent: boolean;
    subpregs: IPreguntaCV[];
    superQId: number;
    tieneRespuestas: boolean;
    visibleActual: boolean;
}

export interface IQModelAccion extends IEntityPathBase<IModelAccion> {
    cv_id: INumberPath<number>;
    cv_id_historic: INumberPath<number>;
    data: IStringPath;
    fc: IDateTimePath<Date>;
    idaction: INumberPath<number>;
    notificacion: IStringPath;
    obvs: IStringPath;
    state: IStringPath;
    who: IStringPath;
}

export interface IQModelAvisoCv extends IEntityPathBase<IModelAvisoCv> {
    destino: IDateTimePath<Date>;
    fcaviso: IDateTimePath<Date>;
    idcv: INumberPath<number>;
    idcvaviso: INumberPath<number>;
    tipoaviso: IStringPath;
}

export interface IQModelBloque extends IEntityPathBase<IModelBloque> {
    descr: IStringPath;
    formular_id: INumberPath<number>;
    idbloq: INumberPath<number>;
    noactivo: IBooleanPath;
    orden: INumberPath<number>;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
}

export interface IQModelCurriculum extends IEntityPathBase<IModelCurriculum> {
    comite_autoriza: IStringPath;
    comite_puesto: IStringPath;
    cvuuid: IStringPath;
    estado: IStringPath;
    fcalta: IDateTimePath<Date>;
    fcenvio: IDateTimePath<Date>;
    fcrevision: IDateTimePath<Date>;
    form_id: INumberPath<number>;
    idcv: INumberPath<number>;
    ip: IStringPath;
    menu_id: INumberPath<number>;
    revisor: IStringPath;
    tkn: IStringPath;
    usualta: IStringPath;
}

export interface IQModelCurriculumEdit extends IEntityPathBase<IModelCurriculumEdit> {
    fcedit: IDateTimePath<Date>;
    idcv: INumberPath<number>;
    idcvedit: INumberPath<number>;
    tipo: IStringPath;
    usuedit: IStringPath;
}

export interface IQModelCurriculumHistoric extends IEntityPathBase<IModelCurriculumHistoric> {
    cvuuid: IStringPath;
    estado: IStringPath;
    fcalta: IDateTimePath<Date>;
    fcenvio: IDateTimePath<Date>;
    fchist: IDateTimePath<Date>;
    fcrevision: IDateTimePath<Date>;
    form_id: INumberPath<number>;
    idcv_orig: INumberPath<number>;
    idcvhist: INumberPath<number>;
    menu_id: INumberPath<number>;
    revisor: IStringPath;
    tkn: IStringPath;
    usualta: IStringPath;
    usuhist: IStringPath;
}

export interface IQModelDocInterno extends IEntityPathBase<IModelDocInterno> {
    cv_id: INumberPath<number>;
    fc: IDateTimePath<Date>;
    iddocint: INumberPath<number>;
    name: IStringPath;
    obvs: IStringPath;
    path: IStringPath;
    tipo: IStringPath;
    who: IStringPath;
}

export interface IQModelDocReq extends IEntityPathBase<IModelDocReq> {
    cond_bool: IBooleanPath;
    cond_fin: IDateTimePath<Date>;
    cond_ini: IDateTimePath<Date>;
    cond_max: INumberPath<number>;
    cond_min: INumberPath<number>;
    cond_opt: IStringPath;
    cond_txt: IStringPath;
    estado: IStringPath;
    idform: INumberPath<number>;
    idquestion: INumberPath<number>;
    idreqdoc: INumberPath<number>;
    tipodoc: IStringPath;
}

export interface IQModelEstadoCv extends IEntityPathBase<IModelEstadoCv> {
    activanotif: IBooleanPath;
    asuntonotif: IStringPath;
    contartotal: IBooleanPath;
    estado: IStringPath;
    idestado: INumberPath<number>;
    notas: IStringPath;
    orden: INumberPath<number>;
    seleccionable: IBooleanPath;
    templatenotif: IStringPath;
    texto_en: IStringPath;
    texto_es: IStringPath;
    tiponotif: IStringPath;
}

export interface IQModelFichero extends IEntityPathBase<IModelFichero> {
    cv_id: INumberPath<number>;
    filename: IStringPath;
    idfile: INumberPath<number>;
    path: IStringPath;
    q_id: INumberPath<number>;
    resp_id: INumberPath<number>;
}

export interface IQModelFilaPreg extends IEntityPathBase<IModelFilaPreg> {
    idfilapreg: INumberPath<number>;
    orden: INumberPath<number>;
    quest_id: INumberPath<number>;
    super_id: INumberPath<number>;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
    valida: IBooleanPath;
}

export interface IQModelFormulario extends IEntityPathBase<IModelFormulario> {
    formorigen: INumberPath<number>;
    idform: INumberPath<number>;
    noDocs: IBooleanPath;
    orden: INumberPath<number>;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
}

export interface IQModelMainQuestion extends IEntityPathBase<IModelMainQuestion> {
    descr: IStringPath;
    idmainq: INumberPath<number>;
    noactivo: IBooleanPath;
    orden: INumberPath<number>;
    qkey: IStringPath;
    texto_en: IStringPath;
    usar_busquedas: IBooleanPath;
    usar_listado: IBooleanPath;
}

export interface IQModelMenu extends IEntityPathBase<IModelMenu> {
    acceso_publico: IBooleanPath;
    aceptar_captcha: IBooleanPath;
    aceptar_terminos_lopd: IBooleanPath;
    activo: IBooleanPath;
    formular_id: INumberPath<number>;
    idmen: INumberPath<number>;
    idmensuper: INumberPath<number>;
    obvs: IStringPath;
    orden: INumberPath<number>;
    seleccionable: IBooleanPath;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
}

export interface IQModelNotificacionDoc extends IEntityPathBase<IModelNotificacionDoc> {
    activanotif: IBooleanPath;
    asunto: IStringPath;
    estado: IStringPath;
    idnotifdoc: INumberPath<number>;
    mail: IStringPath;
    tipodoc: IStringPath;
    todosdocs: IBooleanPath;
}

export interface IQModelNotificacionEstado extends IEntityPathBase<IModelNotificacionEstado> {
    activanotif: IBooleanPath;
    estado: IStringPath;
    idnotifestado: INumberPath<number>;
    mail: IStringPath;
}

export interface IQModelOpt extends IEntityPathBase<IModelOpt> {
    idopt: INumberPath<number>;
    orden: INumberPath<number>;
    pregform_id: INumberPath<number>;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
}

export interface IQModelPregSelect extends IEntityPathBase<IModelPregSelect> {
    idpregselect: INumberPath<number>;
    orden: INumberPath<number>;
    preg_id: INumberPath<number>;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
}

export interface IQModelPregunta extends IEntityPathBase<IModelPregunta> {
    allow_other: IBooleanPath;
    block: IBooleanPath;
    buscar: IBooleanPath;
    details: IBooleanPath;
    details_req: IBooleanPath;
    explanation: IStringPath;
    exportar: IBooleanPath;
    grupo: IStringPath;
    idquest: INumberPath<number>;
    keep_history: IBooleanPath;
    listado: IBooleanPath;
    mainq_id: INumberPath<number>;
    multiple: IBooleanPath;
    notitle: IBooleanPath;
    omit_history_match: IBooleanPath;
    options: IStringPath;
    orden: INumberPath<number>;
    others_max: INumberPath<number>;
    qkey: IStringPath;
    required: IBooleanPath;
    requiredmsg: IStringPath;
    seleccionable: IBooleanPath;
    subpreg: IBooleanPath;
    texto_en: IStringPath;
    texto_id: INumberPath<number>;
    tipoq: IStringPath;
    vista: IStringPath;
}

export interface IQModelPreguntaForm extends IEntityPathBase<IModelPreguntaForm> {
    activo: IBooleanPath;
    allow_obvs: IBooleanPath;
    allow_other: IBooleanPath;
    bloque_id: INumberPath<number>;
    formular_id: INumberPath<number>;
    idformq: INumberPath<number>;
    obvsmsg: IStringPath;
    options: IStringPath;
    orden: INumberPath<number>;
    others_max: INumberPath<number>;
    quest_id: INumberPath<number>;
    required: IBooleanPath;
    requiredmsg: IStringPath;
    visibleEnForm: IBooleanPath;
}

export interface IQModelRespuesta extends IEntityPathBase<IModelRespuesta> {
    cv_id: INumberPath<number>;
    cv_id_historic: INumberPath<number>;
    fc: IDateTimePath<Date>;
    idcvedit: INumberPath<number>;
    idresp: INumberPath<number>;
    idresp_sust: INumberPath<number>;
    idx: INumberPath<number>;
    optidx: INumberPath<number>;
    q_id: INumberPath<number>;
    resp_actual: IBooleanPath;
    resp_bool: IBooleanPath;
    resp_fec: IDateTimePath<Date>;
    resp_fil: IStringPath;
    resp_id: INumberPath<number>;
    resp_num: INumberPath<number>;
    resp_obvs: IStringPath;
    resp_opt: IStringPath;
    resp_txt: IStringPath;
    resp_yndet: IStringPath;
    supq_id: INumberPath<number>;
    tipo: IStringPath;
    valida: IBooleanPath;
}

export interface IQModelRespuestaHistCV extends IEntityPathBase<IModelRespuestaHistCV> {
    cv_id: INumberPath<number>;
    cv_id_historic: INumberPath<number>;
    fcenlace: IDateTimePath<Date>;
    idcvresphist: INumberPath<number>;
    mainq_id: INumberPath<number>;
    q_id: INumberPath<number>;
    resp_id: INumberPath<number>;
    resp_id_hist: INumberPath<number>;
    supq_id: INumberPath<number>;
    tiporesp: IStringPath;
    valor_cv: IStringPath;
    valor_hist: IStringPath;
}

export interface IQModelText extends IEntityPathBase<IModelText> {
    idref: INumberPath<number>;
    idtext: INumberPath<number>;
    text: IStringPath;
    textkey: IStringPath;
    textlng: IStringPath;
}

export interface IQModelTipoDoc extends IEntityPathBase<IModelTipoDoc> {
    grupo: IStringPath;
    idtipo: INumberPath<number>;
    notas: IStringPath;
    orden: INumberPath<number>;
    required: IBooleanPath;
    seleccionable: IBooleanPath;
    texto_en: IStringPath;
    texto_es: IStringPath;
    tipo: IStringPath;
}

export interface IQModelToken extends IEntityPathBase<IModelToken> {
    id: INumberPath<number>;
    rnd: INumberPath<number>;
    uuid: IStringPath;
}

export interface IQModelVUsuariosPP extends IEntityPathBase<IModelVUsuariosPP> {
    activogestor: IBooleanPath;
    buzongestor: IStringPath;
    coddep: IStringPath;
    codseccion: IStringPath;
    iddep: INumberPath<number>;
    idfunc: INumberPath<number>;
    idgestor: INumberPath<number>;
    idseccion: INumberPath<number>;
    langgestor: IStringPath;
    nomdep: IStringPath;
    nomgestor: IStringPath;
    nomseccion: IStringPath;
    pass_gestor: IStringPath;
    user_gestor: IStringPath;
}

export interface IQResp {
    empty: boolean;
    f: Date;
    fil: string;
    idopt: number;
    idref: string;
    idsupref: string;
    idx: number;
    num: number;
    opt: string;
    opts: IQRespOpt[];
    sel: string;
    text: string;
    val: boolean;
    yndet: string;
}

export interface IQRespEdit extends IQResp {
    idresporig: number;
}

export interface IQRespOpt {
    obvs: string;
    opt: string;
}

export interface IRegistrosCoincidencias {
    regs: IModelRespuestaHistCV[];
}

export interface IRegistrosCoincidenciasPreg extends IRegistrosCoincidencias {
    preg: IModelPregunta;
    pregFila: IModelPregunta;
}

export interface IReglaDoc {
    matchCods: boolean;
    matchDoc: boolean;
    preg?: IPreguntaCV;
    regl: IModelDocReq;
    resp?: IRespuestasDePreg;
    valid: boolean;
}

export interface IReglaValidacionDoc {
    regla: IModelDocReq;
}

export interface IReglasDocsCV {
    reglasPorEstado: { [index: string]: IReglasEstadoCV };
}

export interface IReglasEstadoCV {
    estado: string;
    permited: boolean;
    regl: IReglaDoc[];
}

export interface IReporteBorradoCV {
    success: boolean;
}

export interface IReporteCV {
    bloques: IBloqueCV[];
    coincidenciasHist: ICoincidenciasHistEnCv;
    cv: IModelCurriculum;
    docs: IDocsInternosCV;
    form: IFormularioEnCV;
    history: IHistoriaCV;
    listaRespuestas: IListaRespuestasCV;
    regld: IReglasDocsCV;
    respuestas: { [index: string]: IFilaRespuestaCV };
}

export interface IReporteCVHistorico extends IComparable<IReporteCVHistorico> {
    curr: IModelCurriculumHistoric;
    history: IHistoriaCV;
    porPreg: { [index: string]: IRespHistorico };
    regForm: IModelFormulario;
}

export interface IResource extends IInputStreamSource {
    description: string;
    file: IFile;
    filename: string;
    open: boolean;
    readable: boolean;
    uri: IURI;
    url: IURL;
}

export interface IRespHistorico {
    idq: number;
    q: IModelPregunta;
    resp: IModelRespuesta[];
}

export interface IRespuestaCV {
    idq: number;
    idx: number;
    rlist: IFilaRespuestaCV[];
    subresp: IRespuestaCV[];
    tipoF: boolean;
}

export interface IRespuestasDePreg extends IContieneRespuestas {
}

export interface IRespuestasEnHistorico {
    porPreg: { [index: string]: IRespHistorico };
}

export interface IRespuestasHistRelacionadas {
    coincidenciasHist: ICoincidenciaHistorico[];
    pregsForm: string[];
    reporte: IReporteCV;
}

export interface IResultadoAccionCV {
    actionitem: IModelAccion;
    state: IModelEstadoCv;
}

export interface IResultadoDocInternoCV {
    item: IModelDocInterno;
    state: IModelTipoDoc;
}

export interface IResumenEstadosCV {
    allList: ITotalEstadoProj[];
    total: number;
    totalValid: number;
    valid: boolean;
    validList: ITotalEstadoProj[];
}

export interface ISeleccionForm extends IInfoFormular {
}

export interface ISeleccionMenu {
    intro: { [index: string]: IModelText };
    root: IItemMenu[];
}

export interface ISerializable {
}

export interface ISimpleExpression<T> extends IDslExpression<T> {
}

export interface ISlice<T> extends IStreamable<T> {
    content: T[];
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    pageable: IPageable;
    size: number;
    sort: ISort;
}

export interface ISort extends IStreamable<IOrder>, ISerializable {
    sorted: boolean;
    unsorted: boolean;
}

export interface IStream<T> extends IBaseStream<T, IStream<T>> {
}

export interface IStreamable<T> extends IIterable<T>, ISupplier<IStream<T>> {
    empty: boolean;
}

export interface IStringExpression extends ILiteralExpression<string> {
}

export interface IStringPath extends IStringExpression, IPath<string> {
}

export interface ISupplier<T> {
}

export interface ITemporalExpression<T> extends ILiteralExpression<T> {
}

export interface ITextosPorKey {
    porKey: { [P in IKeyTextos]?: IModelText[] };
    sinKey: { [index: string]: IModelText[] };
}

export interface ITiposDatosDoc {
    estados: IEstadoCvNotifStore;
    tipos: ITiposDocumento;
}

export interface ITiposDocumento {
    grupos: IGrupoTipoDoc[];
}

export interface ITotalEstadoProj {
    count: number;
    estado: string;
    estadoLabel: string;
}

export interface IType {
    typeName: string;
}

export interface ITypeVariable<D> extends IType, IAnnotatedElement {
    annotatedBounds: IAnnotatedType[];
    bounds: IType[];
    genericDeclaration: D;
    name: string;
}

export interface IURI extends IComparable<IURI>, ISerializable {
}

export interface IURL extends ISerializable {
}

export interface IValoresBusqueda {
    preg: IFormPregunta;
    sel: string[];
    t: ITipoCondicion;
}

export type ICandidatoApp = "CURR" | "MODIFCONTRATOS";

export type IDirection = "ASC" | "DESC";

export type IKeyTextos = "INTRO";

export type ILangTextos = "es" | "en";

export type INullHandling = "NATIVE" | "NULLS_FIRST" | "NULLS_LAST";

export type IPathType = "ARRAYVALUE" | "ARRAYVALUE_CONSTANT" | "COLLECTION_ANY" | "DELEGATE" | "LISTVALUE" | "LISTVALUE_CONSTANT" | "MAPVALUE" | "MAPVALUE_CONSTANT" | "PROPERTY" | "VARIABLE";

export type ISeleccionPeticionCoincidencias = "TODOS" | "PENDIENTES" | "CVS";

export type ITipoCondicion = "TXT" | "RANGO" | "PERIODO" | "SEL" | "SINO" | "DESCONOCIDO";

export type ITipoCondicionBusqueda = "PREGUNTA" | "FECHAS" | "ESTADO";

export type ITipoEdicionCurr = "ALTA" | "EDIT";

export type ITipoQ = "TEXT" | "MEMO" | "NUMBER" | "YESNO" | "DATE" | "EMAIL" | "MULTIPLE" | "SELECT" | "ROW" | "FILE" | "PARAM" | "PARAM2" | "PARAMOCULTO" | "ERROR";

export type RestResponse<R> = ng.IPromise<R>;

function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
    let result = "";
    for (let i = 0; i < substitutions.length; i++) {
        result += template[i];
        result += encodeURIComponent(substitutions[i]);
    }
    result += template[template.length - 1];
    return result;
}
